import FilledButton from "@/components/button/filled-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { PageTitleComponent } from "@/components/page-title";
import { IonIcon, useIonRouter } from "@ionic/react";
import { checkmarkCircle } from "ionicons/icons";

export default function ProfilingComplete() {
  const navigation = useIonRouter();

  const onComplete = () => {
    navigation.push("/plans/my-plan", "none");
  };

  return (
    <ProfilePageContainer showToolbar={false}>
      <div className="h-full flex flex-col items-center justify-center mx-auto gap-12">
        <IonIcon
          icon={checkmarkCircle}
          className="w-24 h-24 text-primary-500"
        />

        <PageTitleComponent
          title="All done!"
          align="center"
          titleAlign="center"
          descriptionAlign="center"
          description="View my plan"
        />
      </div>
      <div className="mb-4 w-full">
        <FilledButton
          text="See Plan"
          color="dark"
          expand="full"
          onClick={onComplete}
        />
      </div>
    </ProfilePageContainer>
  );
}
